<template>
  <div id="tu">
    <div id="lond"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { gethotSpotAnalysis3 } from "../../../api/bot";
export default {
  name: "tu",
  props: {
    Emotion: {
      type: Array
    }
  },
  data() {
    return {};
  },
  watch: {
    Emotion: {
      handler(newRoom, oldRoom) {
        this.daxian();
      },
      deep: true
    }
  },
  created() {},
  mounted() {
  },

  methods: {
    daxian() {
      //  console.log(this.Emotion,'父子传值了');
      var colorList = ["#005eff", "#ff9194"];
      var option = {
        color: colorList,
        tooltip: {
          trigger: "item"
        },
        legend: {
          top: "5%",
          left: "5%",
          orient: "vertical",
          x: "left",
          data: ["负面", "正面"],
          icon: "circle",
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 16
          }
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "outside"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "40",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: true
            },
            data: this.Emotion
            // [
            //   { value: 32.9, name: "负面", itemStyle: { color: "#005eff" } },
            //   { value: 67.1, name: "正面", itemStyle: { color: "#ff9194" } },
            // ],
          }
        ]
      };
      //初始化echarts实例
      var myChart = echarts.init(document.getElementById("lond"));
      //使用制定的配置项和数据显示图表
      myChart.setOption(option);
      window.onresize = function() {
        myChart.resize();
      };
    }
  }
};
</script>

<style lang="scss" scoped>
#tu {
  width: 100%;
  height: 100%;
}
#lond {
  width: 100%;
  height: 100%;
}
</style>
